export enum DateFormats {
  HOURS_MINS = "HH:mm",
  FULL_DAY_NAME__HOURS_MINS = "cccc HH:mm",
  DAY_NUMBER__SHORT_MONTH__HOURS_MINS = "dd. LLL HH:mm",
  DAY_NUMBER__SHORT_MONTH__YEAR_NUMBER = "dd. LLL yyyy",
}

export const TIMEZONE = "Europe/Copenhagen";
